// extracted by mini-css-extract-plugin
export default {"novaTarefa":"formulario_novaTarefa__XD4cB","inputContainer":"formulario_inputContainer__0Tvqa"};